import clsx from 'clsx'
import Image from 'next/image'
import { useState } from 'react'

import { BASE_URL } from '@/shared/lib/const/env'

import { CardType } from '../../types/types'

import cl from './product-image.module.scss'

const fallbackImg = '/entities/ProductCard/fallback-img.svg'

interface ProductImageProps {
	type?: CardType
	src?: string
	alt?: string
	priority?: boolean
	'data-name'?: string
}

export const ProductImage = (props: ProductImageProps) => {
	// Product tiles are almost always below the fold, so they must NOT preload by default —
	// preloading every tile floods the connection and drowns the real above-the-fold LCP image
	// on mobile. Above-the-fold callers (e.g. first catalog row) can opt in via `priority`.
	const { src, alt = '', type = 'regular', priority = false } = props

	const [imageLoadingError, setImageLoadingError] = useState(false)
	const imageLoadingFallback = () => setImageLoadingError(true)

	const imageUrl = `${BASE_URL}${src}`
	const currentImageUrl = imageLoadingError || !src ? fallbackImg : imageUrl

	const sizes =
		type === 'wide'
			? '90px'
			: type === 'wideOnMobile'
			? '(max-width: 576px) 90px, 180px'
			: '(max-width: 576px) 100px, 180px'

	return (
		<div className={clsx(cl.image, cl[type])}>
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<Image
				src={currentImageUrl}
				alt={alt}
				fill
				style={{ objectFit: 'contain' }}
				sizes={sizes}
				quality={75}
				priority={priority}
				onError={imageLoadingFallback}
				data-name={props['data-name']}
			/>
		</div>
	)
}
